import { withAuthenticationRequired } from '@auth0/auth0-react';
import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Intro from '@app/layout/Intro.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import AiDispatcherSettings from '@app/pages/settings/AiDispatcherSettings.tsx';

const AiDispatcherPage = () => {
  const { tr } = useTranslationLgs();

  return (
    <ResponsiveLayout
      title={tr('AiDispatcher.pageTitle', 'AI dispatcher rules')}
      oneOfPermission={[PermissionTypesEnum.PERMISSION_AI_DISPATCHER_READ, PermissionTypesEnum.PERMISSION_AI_DISPATCHER_RW]}
    >
      <AiDispatcherSettings />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(AiDispatcherPage, {
  onRedirecting: () => <Intro />,
});
